import * as Sentry from "@sentry/react";

let initialized = false;

function scrubEvent(event) {
  if (event?.user) {
    event.user = { id: event.user.id };
  }

  if (event?.request?.headers) {
    delete event.request.headers.Authorization;
    delete event.request.headers.Cookie;
    delete event.request.headers["X-CSRF-Token"];
  }

  return event;
}

export function initAdminSentry(config) {
  if (!config?.enabled || initialized) {
    return;
  }

  Sentry.init({
    dsn: config.dsn,
    environment: config.environment,
    tracesSampleRate: config.traces_sample_rate || 0,
    replaysSessionSampleRate: config.replays_session_sample_rate || 0,
    replaysOnErrorSampleRate: config.replays_on_error_sample_rate || 0,
    beforeSend: scrubEvent,
  });

  initialized = true;
}

export function syncAdminSentryContext({ currentUser, workspaceSchool, view }) {
  if (!initialized) {
    return;
  }

  Sentry.setTag("surface", "admin");
  Sentry.setTag("view", view || "unknown");

  if (workspaceSchool?.id) {
    Sentry.setTag("school_id", String(workspaceSchool.id));
  }

  if (workspaceSchool?.tenantId) {
    Sentry.setTag("tenant_id", String(workspaceSchool.tenantId));
  }

  if (currentUser?.id) {
    Sentry.setUser({ id: String(currentUser.id) });
  } else {
    Sentry.setUser(null);
  }
}
